// MVMNT — main.js
(function () {
  try {
  // Nav condense on scroll
  const nav = document.querySelector('.nav');
  const onScroll = () => {
    if (!nav) return;
    if (window.scrollY > 8) nav.style.background = 'rgba(0,0,0,0.88)';
    else nav.style.background = 'rgba(0,0,0,0.72)';
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // Shop filters
  document.querySelectorAll('[data-filter]').forEach((chip) => {
    chip.addEventListener('click', () => {
      document.querySelectorAll('[data-filter]').forEach((c) => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      const key = chip.dataset.filter;
      document.querySelectorAll('[data-cat]').forEach((card) => {
        card.style.display = (key === 'all' || card.dataset.cat === key) ? '' : 'none';
      });
    });
  });

  // Size selector on PDP
  document.querySelectorAll('.pdp__sizes').forEach((group) => {
    group.querySelectorAll('.size').forEach((s) => {
      s.addEventListener('click', () => {
        if (s.classList.contains('is-oos')) return;
        group.querySelectorAll('.size').forEach((x) => x.classList.remove('is-active'));
        s.classList.add('is-active');
      });
    });
  });

  // Add-to-cart (prototype only)
  document.querySelectorAll('[data-add-cart]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const label = btn.textContent.trim();
      btn.textContent = 'Added ✓';
      setTimeout(() => { btn.textContent = label; }, 1600);
    });
  });

  // Newsletter (prototype only)
  document.querySelectorAll('[data-newsletter]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('button');
      const orig = btn.textContent;
      btn.textContent = 'Thanks';
      form.querySelector('input').value = '';
      setTimeout(() => { btn.textContent = orig; }, 1800);
    });
  });
  } catch (err) { if (window.console) console.error('MVMNT main.js:', err); }
})();
